// extracted by mini-css-extract-plugin
export var cartContainer = "_im-4";
export var gray = "_im-1";
export var itemContainer = "_im-2";
export var itemDetails = "_im-3";
export var strong = "_im-0";